/**
 * FileItem Component (Strategic Version)
 * 
 * This component is copied from @gp/components/FileList/components/FileItem
 * with an additional `renderFileName` prop to support custom wrapping of the
 * file name element (e.g., with Bubble for hover tooltips).
 * case-insensitive file handling for preview
 * 
 */

import React from 'react';
import classnames from 'classnames';
import { FILE_ICONS } from '@gp/constants/icons';

import type { IBaseProps } from '@home/types/common';
import type { IFile } from '@gp/components/FileList/types';

import '@gp/components/FileList/components/FileItem/index.scss';

export interface IFileItemProps extends IBaseProps {
  file?: IFile | null;
  renderActions?: (file?: IFile | null) => React.ReactElement | null;
  onFileNameClick?: (file?: IFile | null) => void;
  onFileNameMouseEnter?: (file?: IFile | null) => void;
  onFileNameMouseLeave?: (file?: IFile | null) => void;
  onMouseEnter?: (file?: IFile | null) => void;
  onMouseLeave?: (file?: IFile | null) => void;
  renderFileName?: (fileNameElement: React.ReactElement) => React.ReactElement;
}

const FileItem: React.FC<IFileItemProps> = (props) => {
  const {
    style,
    className,
    file,
    renderActions,
    onFileNameClick,
    onFileNameMouseEnter,
    onFileNameMouseLeave,
    onMouseEnter,
    onMouseLeave,
    renderFileName,
  } = props;
  const { name = '', format = '' } = file || {};
  // CRITICAL FIX: Convert format to lowercase for case-insensitive icon lookup
  // This ensures files with .PDF, .DOC, .PPT work the same as .pdf, .doc, .ppt
  const fileIcon = FILE_ICONS[format.toLowerCase()];

  const fileNameElement = (
    <div
      className="dbg-common-file-item__file-name-format"
      onClick={(e) => {
        e.stopPropagation();
        onFileNameClick?.(file);
      }}
      onMouseEnter={() => {
        onFileNameMouseEnter?.(file);
      }}
      onMouseLeave={() => {
        onFileNameMouseLeave?.(file);
      }}
    >
      <span className="dbg-common-file-item__file-name">{name}</span>
      {!!format && (
        <>
          <span className="dbg-common-file-item__file-format">.{format}</span>
        </>
      )}
    </div>
  );

  return (
    <div
      style={style}
      className={classnames('dbg-common-file-item', className)}
      onMouseEnter={() => {
        onMouseEnter?.(file);
      }}
      onMouseLeave={() => {
        onMouseLeave?.(file);
      }}
    >
      {fileIcon && (
        <span style={{ backgroundImage: `url("${fileIcon}")` }} className="dbg-common-file-item__file-icon"></span>
      )}
      {renderFileName ? renderFileName(fileNameElement) : fileNameElement}
      {renderActions?.(file)}
    </div>
  );
};

export default FileItem;

